import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PaymentState = {
  dataPayments?: PaymentSettingsType;
};

export const paymentInitialState: PaymentState = {};

export const slice = createSlice({
  name: 'payment',
  initialState: paymentInitialState,
  reducers: {
    setListPaymentsAction(
      state,
      { payload }: PayloadAction<{ dataPayments: PaymentSettingsType }>,
    ) {
      state.dataPayments = payload.dataPayments;
    },
  },
});

export const { setListPaymentsAction } = slice.actions;

export default slice.reducer;
